import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'device-types',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  getURL: 'device-types',
  isMultiSelectable: false,
  emptyMessage: "You don't have contents, visit the content section to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canOpen: true,
      canOrder: false,
      canFilter: true,
      helpText: 'Name of the type.',
    },
    {
      attributeName: 'code',
      label: 'Code',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canOpen: true,
      canOrder: false,
      canFilter: true,
      helpText: 'Code of the type.',
    },
    {
      attributeName: 'platform',
      label: 'Platform',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canOpen: true,
      canOrder: false,
      canFilter: true,
      helpText: 'Platform of the type.',
    },
  ],
};
